import { Accent, TagPill } from '@access-erp/ui-components';
import cn from 'classnames';

import styles from './enquiries-pill.module.scss';

interface ProductFamilyProps {
  value: string | string[];
  accent?: Accent;
  pillSize?: 'medium' | 'large';
  mainProduct?: string;
}
export const EnquiriesPill = ({ value, accent, pillSize, mainProduct }: ProductFamilyProps) => {
  // TODO - temporarily hardcoded these types as we don`t yet have enum created on the backend
  const secondaryBillingTypes = ['Initials', 'Deposit'];
  const primaryBillingTypes = ['Subscription', 'Variable'];
  if (value && Array.isArray(value)) {
    return (
      <div>
        {value.map((el) => (
          <TagPill
            accent={accent ?? 'teal'}
            key={el}
            size={pillSize ?? 'medium'}
            className={cn(styles['product-tag'], {
              [styles['secondary-billing-type']]: secondaryBillingTypes.includes(el),
              [styles['main-billing-type']]: primaryBillingTypes.includes(el),
              [styles['secondary-product']]: el !== mainProduct,
            })}
          >
            {el}
          </TagPill>
        ))}
      </div>
    );
  }

  return null;
};
